/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Suggestions_Welcome_1Inputs */

const es_chat_suggestions_welcome_1 = /** @type {(inputs: Chat_Suggestions_Welcome_1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hola ${i?.name}, ¿en qué puedo ayudarte hoy?`)
};

const en_chat_suggestions_welcome_1 = /** @type {(inputs: Chat_Suggestions_Welcome_1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hello ${i?.name}, how can I help you today?`)
};

/**
* | output |
* | --- |
* | "Hello {name}, how can I help you today?" |
*
* @param {Chat_Suggestions_Welcome_1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_suggestions_welcome_1 = /** @type {((inputs: Chat_Suggestions_Welcome_1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_Welcome_1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_suggestions_welcome_1(inputs)
	return en_chat_suggestions_welcome_1(inputs)
});
export { chat_suggestions_welcome_1 as "chat.suggestions.welcome_1" }